import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import useLayout from "hooks/useLayout";
import Footer from "layout/footer/Footer";
import Nav from "layout/nav/Nav";
import SidebarMenu from "layout/nav/sidebar-menu/SidebarMenu";

const Layout = ({ children }) => {
  useLayout();

  return (
    <>
      <Nav />
      <main>
        <Container>
          <Row className="h-100">
            <SidebarMenu />
            <Col className="h-100" id="contentArea">
              {children}
            </Col>
          </Row>
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default React.memo(Layout);
